import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import DataTable from "examples/Tables/DataTable";
import MDActionConfigurator from "components/MDActionConfigurator";

import {
  getProductList,
  updateProduct,
  createProduct,
} from "actions/productActions";
import { getServiceList } from "actions/serviceActions";
import { getSupplierList } from "actions/supplierActions";
import { getProfile } from "actions/userActions";

function Products() {
  const configuratorRef = useRef(null);
  const dispatch = useDispatch();
  const [menu, setMenu] = useState(null);
  const [selectServices, setSelectServices] = useState([]);
  const [selectSuppliers, setSelectSuppliers] = useState([]);
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    productNumber: "",
    productName: "",
    supplier: {},
    service: {},
    description: "",
    insuredItems: [],
    amount: 0,
    active: true,
    adminNotes: "",
  });

  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);

  const getMe = useSelector((state) => state.getMe);
  const { me } = getMe;

  useEffect(() => {
    // if (me?.length === 0) {
    dispatch(getProfile());
    // }
  }, [dispatch]);

  // const statsProducts = useSelector((state) => state.statsProducts);
  // const { productsStats } = statsProducts;

  const listProducts = useSelector((state) => state.listProducts);
  const { productsList } = listProducts;

  const listServices = useSelector((state) => state.listServices);
  const { servicesList } = listServices;

  const listSuppliers = useSelector((state) => state.listSuppliers);
  const { suppliersList } = listSuppliers;

  // useEffect(() => {
  //   if (productsStats?.length === 0) {
  //     dispatch(getProductStats());
  //   }
  // }, [dispatch, productsStats?.length]);

  useEffect(() => {
    if (productsList?.length === 0) {
      dispatch(getProductList());
    }
  }, [dispatch, productsList?.length]);

  useEffect(() => {
    if (servicesList?.length === 0) {
      dispatch(getServiceList());
    }
    setSelectServices(
      servicesList?.map((item) => ({
        value: item._id,
        name: item.mainService + " - " + item.service,
      }))
    );
  }, [dispatch, servicesList?.length]);

  useEffect(() => {
    if (suppliersList?.length === 0) {
      dispatch(getSupplierList());
    }
    setSelectSuppliers(
      suppliersList?.map((item) => ({
        value: item._id,
        name: item.supplierName,
      }))
    );
  }, [dispatch, suppliersList?.length]);

  const handleToggleBackdrop = (item, state) => {
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const handleSubmitProduct = (e) => {
    console.log("🚀 ~ file: index.js:55 ~ handleSubmitProduct ~ e:", e);
    if (currentState === "edit") {
      console.log("product updating");
      dispatch(updateProduct(currentData?._id, e));
    } else {
      console.log("product creating");
      dispatch(createProduct(e));
    }
    handleToggleBackdrop({}, "");
  };

  const renderMenu = (
    <Menu
      id="simple-menu"
      anchorEl={menu}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(menu)}
      onClose={closeMenu}
    >
      <MenuItem onClick={closeMenu}>Option 1</MenuItem>
      <MenuItem onClick={closeMenu}>Option 2</MenuItem>
      <MenuItem onClick={closeMenu}>Option 3</MenuItem>
    </Menu>
  );

  const Supplier = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} name={name} size="sm" />
      <MDBox>
        <MDTypography
          variant="button"
          fontWeight="medium"
          ml={1}
          lineHeight={1}
          sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
        >
          {name}
        </MDTypography>
        <MDBox mt={1.5}>
          <MDTypography
            variant="button"
            fontSize="small"
            ml={1}
            lineHeight={1}
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
          >
            {email}
          </MDTypography>
        </MDBox>
      </MDBox>
    </MDBox>
  );

  function renderRows(data) {
    const values = [];
    data?.forEach((item, index) => {
      const newElement = {
        supplier: (
          <Link to={`/products/${item?._id}`}>
            <Supplier
              key={index}
              image={item?.supplier?.supplierLogo}
              name={item?.supplier?.supplierName}
              email={item?.supplier?.supplierEmail}
            />
          </Link>
        ),
        product: (
          <MDTypography
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            fontWeight="medium"
          >
            {item?.productName}
          </MDTypography>
        ),
        productNumber: (
          <MDTypography
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            fontWeight="medium"
          >
            {item.productNumber}
          </MDTypography>
        ),
        service: (
          <MDBox>
            <MDTypography
              variant="caption"
              sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
              fontWeight="medium"
            >
              {item?.service?.service}
            </MDTypography>
            <MDBox mt={1}>
              <MDTypography
                variant="caption"
                sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
                fontWeight="medium"
              >
                {item?.service?.mainService}
              </MDTypography>
            </MDBox>
          </MDBox>
        ),
        amount: (
          <MDBox>
            <MDTypography
              variant="caption"
              sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
              fontWeight="medium"
            >
              Ksh. {item?.amount}
            </MDTypography>
            {/* <MDBox mt={1}>
              <MDTypography
                variant="caption"
                sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
                fontWeight="medium"
              >
                {item?.premiumPercentage}%
              </MDTypography>
            </MDBox> */}
          </MDBox>
        ),
        addons: (
          <MDTypography
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            fontWeight="medium"
          >
            {item?.addons?.length} items
          </MDTypography>
        ),
      };
      values.push(newElement);
    });
    return values;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={12} lg={12}>
            <MDBox p={2} mt="auto" display="flex" justifyContent="end">
              {(me?.role === "super_admin" || me?.role === "admin") && (
                <MDButton
                  component="a"
                  href="#"
                  rel="noreferrer"
                  variant="gradient"
                  color="light"
                  onClick={() =>
                    handleToggleBackdrop(
                      {
                        _id: "",
                        productNumber: "",
                        productName: "",
                        supplier: {},
                        service: {},
                        description: "",
                        insuredItems: [],
                        amount: 0,
                        active: true,
                        adminNotes: "",
                      },
                      ""
                    )
                  }
                >
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  &nbsp;New Product
                </MDButton>
              )}
            </MDBox>
            <MDBox>
              <DataTable
                table={{
                  columns: [
                    {
                      Header: "supplier",
                      accessor: "supplier",
                      width: "25%",
                      align: "left",
                    },
                    {
                      Header: "product",
                      accessor: "product",
                      accessorKey: "product",
                      width: "15%",
                      align: "left",
                    },
                    {
                      Header: "productNumber",
                      accessor: "productNumber",
                      width: "15%",
                      align: "left",
                    },
                    {
                      Header: "service",
                      accessor: "service",
                      width: "15%",
                      align: "left",
                    },
                    {
                      Header: "amount",
                      accessor: "amount",
                      width: "15%",
                      align: "left",
                    },
                    {
                      Header: "addons",
                      accessor: "addons",
                      width: "15%",
                      align: "left",
                    },
                  ],

                  rows: renderRows(productsList),
                }}
                showTotalEntries={true}
                isSorted={true}
                // noEndBorder
                entriesPerPage={false}
                canSearch={false}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>

      <MDActionConfigurator
        ref={configuratorRef}
        title="Product Config"
        onCompleteConfig={handleSubmitProduct}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Product Number",
            placeholderType: "Enter Product Number",
            dataType: "text",
            keyType: "productNumber",
            valueType: currentData?.productNumber,
          },
          {
            labelType: "Product Name",
            placeholderType: "Enter Product Name",
            dataType: "text",
            keyType: "productName",
            valueType: currentData?.productName,
          },
          {
            labelType: "Supplier",
            placeholderType: "Select Supplier",
            dataType: "select",
            keyType: "supplier",
            valueType: currentData?.supplier?._id,
            options: selectSuppliers,
          },
          {
            labelType: "Service",
            placeholderType: "Select Service",
            dataType: "select",
            keyType: "service",
            valueType: currentData?.service?._id,
            options: selectServices,
          },
          {
            labelType: "Description",
            placeholderType: "Enter Description",
            dataType: "textarea",
            keyType: "description",
            valueType: currentData?.description,
          },
          {
            labelType: "Insured Items",
            placeholderType: "Enter Insured Items",
            dataType: "textinputchip",
            keyType: "insuredItems",
            valueType: currentData?.insuredItems,
            options: currentData?.insuredItems,
          },
          {
            labelType: "Premium Amount",
            placeholderType: "Enter Premium Amount",
            dataType: "number",
            keyType: "amount",
            valueType: currentData?.amount,
          },

          {
            labelType: "Admin Note (optional)",
            placeholderType: "Enter Admin Note",
            dataType: "textarea",
            keyType: "adminNotes",
            valueType: currentData?.adminNotes,
          },
          {
            labelType: "Active",
            placeholderType: "Active",
            dataType: "active",
            keyType: "active",
            valueType: currentData?.active,
          },
        ]}
        state={currentState}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default Products;
